import React from 'react';
import styles from './Contact.module.css';

import Project from '../../../assets/Contact.jpg';

const Contact = () => {
  return (
    <div id="contact" className={styles.container}>
      <h1 className={styles.title}>Contact Us for a Custom Bid</h1>
      <div className={styles.contactInfo}>
        <div className={styles.contactItem}>
          <div className={styles.contactText}>
            <h2>Email</h2>
            <p className={styles.email}>
              <a href="mailto:moralestrim23@yahoo.com" className={styles.link}>
                  moralestrim23@yahoo.com
              </a>
            </p>
            <h2>Phone</h2>
            <p className={styles.phone}>
              <a href="tel:5125762311" className={styles.link}>
                512-576-2311
              </a>
            </p>
          </div>
          <div className={styles.contactImage}>
            <img src={Project} alt="Construction" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
